import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import axios from 'axios';
import OrganizationLayout from './OrganizationLayout';
import OnboardingWizard from '../components/OnboardingWizard';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getStoredUser = () => {
  try { return JSON.parse(localStorage.getItem('user') || 'null'); } catch { return null; }
};

const SEASON_STORAGE_KEY = 'tasyar_selected_season';

// القالب الموحد لجميع صفحات المنشأة: يجلب المستخدم والمنشأة مرة واحدة
// ويبقي Sidebar/TopBar ثابتين أثناء التنقل، والمحتوى يتغير عبر <Outlet/>
export default function OrganizationShell() {
  const [user, setUser] = useState(getStoredUser());
  const [club, setClub] = useState(null);
  const [trialStatus, setTrialStatus] = useState(null);
  const [settings, setSettings] = useState(null);
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [seasons, setSeasons] = useState([]);
  const [selectedSeasonId, setSelectedSeasonIdState] = useState(() => localStorage.getItem(SEASON_STORAGE_KEY) || 'all');

  const setSelectedSeasonId = (val) => {
    setSelectedSeasonIdState(val);
    try { localStorage.setItem(SEASON_STORAGE_KEY, val); } catch { /* noop */ }
  };

  const loadSeasons = () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    const auth = { headers: { Authorization: `Bearer ${token}` } };
    axios.get(`${API}/seasons`, auth).then((r) => setSeasons(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    const auth = { headers: { Authorization: `Bearer ${token}` } };
    Promise.allSettled([
      axios.get(`${API}/auth/me`, auth),
      axios.get(`${API}/clubs/current`, auth),
      axios.get(`${API}/club-settings`, auth),
      axios.get(`${API}/saas/my-club/trial-status`, auth),
      axios.get(`${API}/seasons`, auth),
    ]).then(([meRes, clubRes, settingsRes, trialRes, seasonsRes]) => {
      const meData = meRes.status === 'fulfilled' ? meRes.value.data : null;
      if (meData) setUser(meData);
      const clubData = clubRes.status === 'fulfilled' ? clubRes.value.data : null;
      const settingsData = settingsRes.status === 'fulfilled' ? settingsRes.value.data : null;
      if (clubData || settingsData) {
        setClub({
          ...(clubData || {}),
          name: settingsData?.club_name || clubData?.name,
          logo_file_id: settingsData?.logo_file_id || clubData?.logo_file_id,
        });
      }
      if (settingsData) setSettings(settingsData);
      if (trialRes.status === 'fulfilled') setTrialStatus(trialRes.value.data);
      if (seasonsRes.status === 'fulfilled') setSeasons(Array.isArray(seasonsRes.value.data) ? seasonsRes.value.data : []);
      if (settingsData && !settingsData.onboarding_completed && meData?.role === 'admin') setShowOnboarding(true);
    });
  }, []);

  useEffect(() => {
    const openHandler = () => setShowOnboarding(true);
    const seasonsHandler = () => loadSeasons();
    window.addEventListener('open-onboarding-wizard', openHandler);
    window.addEventListener('seasons-updated', seasonsHandler);
    return () => {
      window.removeEventListener('open-onboarding-wizard', openHandler);
      window.removeEventListener('seasons-updated', seasonsHandler);
    };
  }, []);

  const seasonCtx = { seasons, selectedSeasonId, setSelectedSeasonId };

  return (
    <OrganizationLayout club={club} user={user} trialStatus={trialStatus} seasons={seasons} selectedSeasonId={selectedSeasonId} setSelectedSeasonId={setSelectedSeasonId}>
      <Outlet context={{ user, club, trialStatus, ...seasonCtx }} />
      <OnboardingWizard open={showOnboarding} settings={settings} onClose={() => setShowOnboarding(false)} />
    </OrganizationLayout>
  );
}
